import hljs from 'highlight.js/lib/core';
import http from 'highlight.js/lib/languages/http';
import json from 'highlight.js/lib/languages/json';
hljs.registerLanguage('http', http);
hljs.registerLanguage('json', json);

document.addEventListener("turbolinks:load", function() {
  const blocks = document.querySelectorAll('pre code')

  if (!blocks) {
    return
  }

  blocks.forEach((block) => {
    hljs.highlightBlock(block);
  });
})
